<template>
  <div class="rj-col-1">
    <div class="rj-baseinfo">
      <div class="rj-baseinfo__label">
        收款银行：
      </div>
      <div class="rj-baseinfo__item bank-info">
        <el-form-item>
          <el-radio-group v-model="form.rbankId">
            <el-radio
              v-for="bank in bankInfos"
              :key="bank.openBankId"
              :label="bank.openBankId"
            >
              {{ bank.openBankName }}
            </el-radio>
          </el-radio-group>
        </el-form-item>
      </div>
    </div>
  </div>
</template>

<script type="es6">
import { getBankInfoBySupplyUnitCode } from '@/API';

export default {
  model: {
    prop: 'form',
    event: 'change'
  },

  props: {
    form: {
      type: Object,
      default: () => { return {}; }
    },

    contractNum: {
      type: [String, Number],
      default: () => { return ''; }
    }
  },

  data () {
    return {
      bankInfos: [],
      isFirst: true
    };
  },

  watch: {
    'form.supplyUnitId' (val) {
      this.initData();
    }
  },

  mounted () {
    this.initData();
  },

  methods: {
    searchBank (code) {
      getBankInfoBySupplyUnitCode(code).then((res) => {
        let { status, data } = res.data;
        if (status === '200') {
          data.forEach((item) => {
            if (item.isDefault && !this.form.rbankId) {
              this.form.rbankId = item.openBankId;
            }
          });
          this.bankInfos = data;
          this.isFirst = false;
        }
      });
    },

    initData () {
      if (this.form.supplyUnitId) {
        this.searchBank({
          'id': this.form.supplyUnitId,
          'contractNum': this.contractNum
        });
      }
    }
  }

};
</script>

<style>
  .bank-info {
    margin-top: 20px;
  }
</style>
